"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGtxId = void 0;
const utils_1 = require("./utils");
const TTL = 3 * 60 * 1000; // 3 minutes
const GtxIdKeyName = 'revjet.gtx.id';
const GtxTsKeyName = 'revjet.gtx.ts';
function exportGtxId(timestamp) {
    const newGtxId = (0, utils_1.generateUniqueId)();
    if (typeof window !== 'undefined') {
        window.sessionStorage.setItem(GtxIdKeyName, newGtxId);
        window.sessionStorage.setItem(GtxTsKeyName, String(timestamp));
    }
    return newGtxId;
}
function getGtxId() {
    const timestamp = new Date().getTime();
    const gtxId = typeof window !== 'undefined' ? window.sessionStorage.getItem(GtxIdKeyName) : null;
    const gtxTimestamp = typeof window !== 'undefined' ? window.sessionStorage.getItem(GtxTsKeyName) : null;
    if (gtxId != null && gtxTimestamp != null) {
        return timestamp > parseInt(gtxTimestamp, 10) + TTL ? exportGtxId(timestamp) : gtxId;
    }
    else {
        return exportGtxId(timestamp);
    }
}
exports.getGtxId = getGtxId;
//# sourceMappingURL=gtx-id.js.map